import {
    CHANGE_APPROACH,
    CHANGE_CURRENCY,
    CHANGE_METHOD,
    CHANGE_SIDE,
    EXIT_MAKET,
    GET_CHARTS_SETTINGS,
    GET_ENTRY_PRICE,
    GET_MARKET_PRICE,
    GET_MODEL_TOTAL_STATUS,

    GET_TRANSACTIONS_DETAILS,
    TOGGLE_BINANCE_STATUS,
    TOGGLE_MODEL_STATUS,
    TOGGLE_RENKO_STATUS,
    UPDATE_SETTINGS,
    UPDATE_WALLET_CONFIG
} from "../actions/constants";
import { currencies } from "../../staticData/currencies";
import { parisfyData } from "../../utils/common-functions";
export const currenciesReducer = (state = currencies, { type, payload }) => {
    // const stateCopy = parisfyData({ ...state });
    const stateCopy = { ...state };
    switch (type) {
        case CHANGE_APPROACH:
            return {
                ...payload
            };
        case CHANGE_METHOD:
            return {
                ...payload
            };
        case UPDATE_WALLET_CONFIG:
            return {
                ...payload
            };
        case GET_CHARTS_SETTINGS:
            return {
                ...payload
            };
        case UPDATE_SETTINGS:
            return {
                ...payload
            };
        case TOGGLE_RENKO_STATUS:
            return {
                ...payload
            };
        case TOGGLE_MODEL_STATUS:
            return {
                ...payload
            };
        case TOGGLE_BINANCE_STATUS:
            return {
                ...payload
            };
        case GET_TRANSACTIONS_DETAILS:
            return {
                ...payload
            };
        case EXIT_MAKET:
            return {
                ...payload
            };
        case GET_MODEL_TOTAL_STATUS:
            stateCopy[payload.currencyId] = {
                ...stateCopy[payload.currencyId],
                totalStatus: {
                    ...stateCopy[payload.currencyId]
                        .totalStatus,
                    ...payload.data
                },
                realTimeStatus: {
                    ...stateCopy[payload.currencyId]
                        .realTimeStatus,
                    candleClosePrice: payload.data.isPositionOpen
                        ? payload.data.accumulativeProfit
                        : "",
                    entrySide: payload.data.isPositionOpen
                        ? payload.data.activePosition
                        : ""
                }
            }
            return {
                ...stateCopy,
            };
        case GET_ENTRY_PRICE:
            stateCopy[payload.currencyId].realTimeStatus = {
                candleClosePrice: payload.data,
                entrySide: payload.side
            }
            return {
                ...stateCopy
            };
        case GET_MARKET_PRICE: {
            stateCopy[payload.currencyId].marketPrice = payload.data
            return {
                ...stateCopy
            };
        }
        // case GET_RENKO_DATA:
        //     return {
        //         ...state,
        //         [payload.currencyId]: {
        //             ...state[payload.currencyId],
        //             [payload.side]: {
        //                 ...state[payload.currencyId][payload.side]
        //             }
        //         }
        //     };
        default:
            return state;
    }
};

export const changeCurrencyIdReducer = (state = "AAVE", { type, payload }) => {
    switch (type) {
        case CHANGE_CURRENCY:
            return payload;
        default:
            return state;
    }
};
export const changeSideReducer = (
    state = {
        side: "BUY",
        sideLabel: "BUY",
        value: "BUY"
    },
    { type, payload }
) => {
    switch (type) {
        case CHANGE_SIDE:
            return payload;
        default:
            return state;
    }
};


